import {
  Paper,
  Box,
  useMantineColorScheme,
  Group,
  Stack,
  ActionIcon,
} from '@mantine/core'
import { PropsWithChildren } from 'react'
import { Navigate, To } from 'react-router-dom'
import { ConnectedLifeLogo, LanguagePicker } from '..'
import { Helmet } from 'components/common/Helmet'
import { TbSettings } from 'react-icons/tb'
import { openDisplaySettings } from './UserHeader'
import { useTranslation } from 'react-i18next'
import classes from './AuthLayout.module.css'

export const AuthLayout = ({
  children,
  bg,
  isLoggedIn,
  redirectTo,
  title,
}: PropsWithChildren<{
  bg: string
  isLoggedIn: boolean
  redirectTo: To
  title?: string | null
}>) => {
  if (isLoggedIn) return <Navigate to={redirectTo} />
  return (
    <>
      {title && (
        <Helmet>
          <title>{title} | Connected Life</title>
        </Helmet>
      )}
      <AuthView bg={bg}>{children}</AuthView>
    </>
  )
}

export const AuthView = ({
  bg,
  children,
}: PropsWithChildren<{ bg: string }>) => {
  const { t } = useTranslation()
  const { colorScheme } = useMantineColorScheme()

  return (
    <div className={classes.wrapper} style={{ backgroundImage: `url(${bg})` }}>
      <Paper className={classes.form} radius={0} p={30}>
        <LanguagePicker />
        <Group justify={'space-between'} align={'end'} my="xl">
          <Box className={classes.logo}>
            <ConnectedLifeLogo
              theme={colorScheme === 'dark' ? 'dark' : 'light'}
            />
          </Box>
          <ActionIcon
            aria-label="Settings"
            variant="transparent"
            onClick={() => openDisplaySettings(t)}
          >
            <TbSettings size="1.2rem" />
          </ActionIcon>
        </Group>
        <Stack gap={'sm'}>{children}</Stack>
      </Paper>
    </div>
  )
}
